
export const HOUSE_ADVANTAGE_TERMINAL_SETTING_NAME = 'house-advantage-card-regex';
export const HIDE_NAVBAR_INFO_BUTTON = 'pt-hide-navbar-info-button';
